import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_SEARCH_RESULT_COUNT,
  DEFAULT_SELECTED_PAGE_INDEX,
  DATA_LOAD_STATUS,
} from "../../constants/metaData";

function extractValue(payload) {
  return payload !== null && payload !== ""
    ? payload.value !== null
      ? payload.value
      : []
    : [];
}

const initialState = {
  value: [],
  searchResultCount: DEFAULT_SEARCH_RESULT_COUNT,
  selectedPageIndex: DEFAULT_SELECTED_PAGE_INDEX,
  selectedIfsDocuments: [],
  selectedIfsDocumentCount: 0,
  documentSearchProgress: DATA_LOAD_STATUS.onStart,
  activeButton: null,
};

const filteredSearchSlice = createSlice({
  name: "documents/filteredSearch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_SEARCH_Filtered", (state, action) => {
        state.value = extractValue(action.payload);
      })
      .addCase("SET_INITIAL_VALUE", (state) => {
        state.value = [];
        state.searchResultCount = -1;
      })
      .addCase("ON_IFS_DOCUMENTS_SELECTED", (state, action) => {
        const p = action.payload;
        if (p != null) {
          state.selectedIfsDocuments = p;
          state.selectedIfsDocumentCount = p.length;
        } else {
          state.selectedIfsDocuments = [];
          state.selectedIfsDocumentCount = 0;
        }
      })
      .addCase("GET_RECENT_DOCUMENT_BY_USER", (state, action) => {
        state.value = action.payload.value;
      })
      .addCase("ON_SEARCH_RESULT_COUNT_CHANGE", (state, action) => {
        const p = action.payload;
        state.searchResultCount =
          p !== "" ? (p.value != null ? (p.value?.length ?? 0) : 0) : 0;
      })
      .addCase("ON_IFS_SEARCH_RESULT_COUNT_CHANGE", (state, action) => {
        state.searchResultCount = action.payload != null ? action.payload : 0;
      })
      .addCase("ON_SELECTED_PAGE_INDEX_CHANGE", (state, action) => {
        state.selectedPageIndex = action.payload;
      })
      .addCase("ON_PAGE_CHANGE", (state, action) => {
        state.value = action.payload;
      })
      .addCase("ON_SET_DOCUMENT_INITIAL_STATE", (state, action) => {
        state.value = action.payload;
        state.searchResultCount = 0;
        state.selectedPageIndex = 0;
      })
      .addCase("ON_IFS_DOCUMENT_LOAD_CHANGED", (state, action) => {
        state.documentSearchProgress = action.payload;
      })
      .addCase("SET_ACTIVE_BUTTON", (state, action) => {
        state.activeButton = action.payload;
      });
  },
});

export default filteredSearchSlice.reducer;
